import type { FroalaOptions } from "froala-editor";

/** At least as long as the `minimal` preset's 8 buttons, which `@duo/editor` merges index by index. */
const AD_TEXT_TOOLBAR_BUTTONS = [
  "paragraphFormat",
  "bold",
  "italic",
  "underline",
  "|",
  "formatOL",
  "formatUL",
  "|",
  "insertLink",
];

export const AD_TEXT_EDITOR_CONFIG: Partial<FroalaOptions> = {
  heightMin: 250,
  paragraphFormat: {
    N: "Normal",
    H2: "Heading 2",
    H3: "Heading 3",
    H4: "Heading 4",
  },
  toolbarButtons: {
    moreText: {
      buttons: AD_TEXT_TOOLBAR_BUTTONS,
      buttonsVisible: AD_TEXT_TOOLBAR_BUTTONS.length,
      align: "left",
    },
  },
};
